module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/post-icon-dd224e77dfba5a88558344193e51f22b.png";